module.exports = __webpack_public_path__ + "img/tx2.f090da47.png";